import { useEffect, useState } from 'react';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import './github-markdown-light.css';

const MarkdownRenderer = ({ markdownText }) => {
    const [htmlOutput, setHtmlOutput] = useState('');
    useEffect(() => {
        if (!markdownText) {
            setHtmlOutput('');
            return;
        }

        // Clean markdown by removing triple backtick code blocks
        let cleanedMarkdown = markdownText.trim();

        // Check if content is wrapped in triple backticks
        if (cleanedMarkdown.startsWith('```') && cleanedMarkdown.endsWith('```')) {
            const lines = cleanedMarkdown.split('\n');

            // Remove first and last line if they contain only backticks
            if (lines.length > 1) {
                const firstLine = lines[0].trim();
                const lastLine = lines[lines.length - 1].trim();

                if (firstLine === '```' && lastLine === '```') {
                    cleanedMarkdown = lines.slice(1, -1).join('\n');
                }
                // Handle language specifiers (e.g., ```markdown)
                else if (firstLine.startsWith('```') && lastLine === '```') {
                    cleanedMarkdown = lines.slice(1, -1).join('\n');
                }
            }

        }
        else if (cleanedMarkdown.endsWith('```')) {
            // If it ends with triple backticks, remove the last line
            const lines = cleanedMarkdown.split('\n');
            cleanedMarkdown = lines.slice(0, -1).join('\n');
        }

       cleanedMarkdown = cleanedMarkdown.replace('```', '');


        // Configure marked
        const options = {
            headerIds: false,
            mangle: false
        };

        // Convert markdown to HTML


        const rawHtml = marked.parse(cleanedMarkdown, options);

        // Sanitize HTML
        const cleanHtml = DOMPurify.sanitize(rawHtml);

        // Update state
        setHtmlOutput(cleanHtml);
    },[]);  // Re-run when markdownText changes

    return (
        <div
            id="output"
            className="content markdown-body"
            dangerouslySetInnerHTML={{ __html: htmlOutput }}
        />
    );
};

export default MarkdownRenderer;